<app-table *ngIf="userList"
           [dataSource]="dataSource"
           [columnDefinition]="displayedColumns">
</app-table>
